module.exports = __webpack_public_path__ + "img/PLAY.830c083b.svg";